import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { Provider } from "react-redux";
import ReduxThunk from 'redux-thunk'
import authReducer from './redux/reducers/authReducer';
import { BrowserRouter } from 'react-router-dom';
import employeeReducer from './redux/reducers/employeeReducer';
import resetPasswordReducer from './redux/reducers/resetPasswordReducer';
import roleReducer from './redux/reducers/roleReducer';
import productReducer from './redux/reducers/productReducer';
import agentReducer from './redux/reducers/agentReducer';
import transactionReducer from './redux/reducers/transactionReducer';
import reportReducer from './redux/reducers/reportReducer';
import collectorReducer from './redux/reducers/collectorReducer';
import correctionReducer from './redux/reducers/correctionReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
  auth: authReducer,
  employee:employeeReducer,
  resetPassword:resetPasswordReducer,
  roles:roleReducer,
  products:productReducer,
  agents:agentReducer,
  transactions:transactionReducer,
  report:reportReducer,
  collector:collectorReducer,
  correction:correctionReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(ReduxThunk))
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
